module.exports = __webpack_public_path__ + "img/bg.6d10c206.png";